<template>


      <div>
        <h1 class="sr-only">Command Center</h1>

        <div class="d-flex">
          <div class="d-none d-lg-block" v-if="$route.name !=='Settings-Home'">
            <div class="card bg-light settings-menu ">
              <div class="card-body">
                <nav class="navbar navbar-expand-md">
              <div class="d-md-block w-100">
                <div class="d-flex align-items-center justify-content-sm-start">
                  <div class="lead pointer" @click="router.push({name: 'Settings-Home'})">Command Center</div>
                  <button class="navbar-toggler ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerSettings" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                  </button>
                </div>



                <div class="collapse navbar-collapse flex-column justify-content-sm-start" id="navbarTogglerSettings">
                  <hr>
                  <div v-for="parent in navItems" :key="parent.label" class="w-100 mb-4">
                    <div class="fw-bold text-uppercase">{{ parent.label }}</div>
                    <ul class="nav flex-column nav-pills">
                      <li class="nav-item" v-for="nav in parent.children" :key="nav.routeName">
                        <router-link :to="{name: nav.routeName}" class="nav-link" :class="{active:$route.matched.some(r => r.name === nav.routeName)}" :title="nav.label">
                          <i :class="`bi me-2 ${nav.icon} ${$route.matched.some(r => r.name === nav.routeName)?'text-white-50':'text-secondary'}`"></i>
                          <span class="d-inline d-md-none d-lg-inline">{{ nav.label }}</span>
                        </router-link>
                      </li>
                    </ul>
                  </div>

                </div>
              </div>
            </nav>
              </div>
            </div>
          </div>
          <div class="flex-grow-1" style="min-width:0" :class="{container:$route.name!=='Settings-Home'}">
            <div v-if="$route.name!=='Settings-Home'" class="small text-primary pointer mb-3" @click="router.push({name: 'Settings-Home'})">
              <i class="bi bi-arrow-left mr-2"></i>
              Command Center
            </div>
            <transition mode="out-in">
              <router-view :nav-items="navItems" />
            </transition>
          </div>
        </div>
      </div>


</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
const store = useStore();
const router = useRouter();
const myPlugins = computed(() => store.state.eshop.eshop?.plugins || [])

const navItems = computed(() => {
  const sellingPlatforms = [
    {
      label: 'Crosslisting',
      routeName: 'Settings-Crosslisting',
      icon: 'bi-diagram-2',
      description: "Sell on Poshmark, Depop, and more. Enable manual order entries for other platforms."
    },
  ]

  const integrationChildren = []
  if (myPlugins.value.length > 0) {
    integrationChildren.push({
      label: 'Plugins',
      routeName: 'Settings-Plugins',
      icon: 'bi-plug-fill',
      description: "Third-party integrations and add-ons connected to your account."
    })
  }

  return [
    {
      label: 'My eBay',
      children: [
        { label: 'eBay Connection',      routeName: 'Settings-Ebay',          icon: 'bi-link',            description: "Connect, refresh, or revoke your eBay account access." },
        { label: 'Custom Label (SKU)',    routeName: 'Settings-CustomLabel',   icon: 'bi-tag',             description: "Set how eShopCommand uses eBay's Custom Label (SKU) field when importing and grouping listings." },
        { label: 'Inventory Sync',       routeName: 'Settings-DataItems',     icon: 'bi-arrow-clockwise', description: "Reimport and refresh your listings and inventory from eBay." },
        { label: 'Shipping',             routeName: 'Settings-DataShipping',  icon: 'bi-truck',           description: "When eBay can't assign a shipping label to a specific order — like combined shipments — resolve and split the cost here." },
        { label: 'Cost of Goods',        routeName: 'Settings-DataCogs',      icon: 'bi-box-seam',        description: "Fix COGS on returns and cancellations not applied correctly." },
        { label: 'Refunds',              routeName: 'Settings-DataRefunds',   icon: 'bi-arrow-return-left', description: "Review eBay refunds and mark as returned or dismiss." },
      ]
    },
    {
      label: 'My Sources',
      children: [
        { label: 'Source Locations',  routeName: 'Settings-SourceLocations', icon: 'bi-geo-alt',        description: "Manage the places where you buy inventory to flip." },
      ]
    },
    {
      label: 'Selling Platforms',
      children: sellingPlatforms
    },
    ...(integrationChildren.length > 0 ? [{ label: 'Integrations', children: integrationChildren }] : []),
    {
      label: 'Account',
      children: [
        { label: 'Profile',             routeName: 'Settings-Profile',    icon: 'bi-person-circle',       description: "Update your name, avatar, and public profile details." },
        { label: 'Login & Security',    routeName: 'Settings-Password',   icon: 'bi-lock',                description: "Change your password and manage account security." },
        { label: 'Timezone & Date',     routeName: 'Settings-Datetime',   icon: 'bi-calendar-week',       description: "Set your eshop's timezone and date display preferences." },
        { label: 'Billing',             routeName: 'Settings-Billing',    icon: 'bi-credit-card-2-front', description: "Manage your subscription and billing." },
      ]
    },
    {
      label: 'Help',
      children: [
        { label: 'Support Center',    routeName: 'Settings-Support',      icon: 'bi-question-circle',     description: "Quick start videos, FAQs, and how to reach us." },
      ]
    },
  ]
})
</script>

<style lang="scss" scoped>
.settings-menu {
  width: 250px;
  //margin-right:2rem;
}
</style>


